<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100" v-if="isloaded">
			<div class="sf-col sf-col-4 qms-multi-selection">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="position-relative sf-col sf-col-16" style="overflow: hidden">
				<sf-card class="p-0 h-100 border-0 bg-transparent">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId" @PopupOpen="PopupOpen"></table-view>
				</sf-card>
			</div>
			<div class="position-relative sf-col sf-col-4" style="overflow: hidden">
				<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="refresh" />
				<form-view :scrId="scrId"></form-view>
			</div>
		</div>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';
import FormView from './Table/Form';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { isloaded: false };
	},
	async created() {
		try {
			this.isloaded = false;
			this.$sf_toggleLoading(true);
			await this.getCommCodes_({ key: 'ipnWayList', codeType: 'IPN_WAY' });
			await this.getCommCodes_({ key: 'icrtList', codeType: 'ICRT' });
			await this.getCommCodes_({ key: 'lgrpList', codeType: 'LGRP' });
			await this.getCommCodes_({ key: 'utmList', codeType: 'UTM' });
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });
			await this.getAllSgrpList_();
			this.setState_({ key: 'isPqyUser', value: await this.inclManyUsrGrp_(['PQYAP', 'PQYRV', 'PQYRG', 'OS']) });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isloaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, FormView, ExcelUploadModal },
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style lang="scss">
.qms-multi-selection {
	.sf-card__content {
		height: 100%;
		overflow-y: hidden;
	}
}
</style>
